// @flow
import React from "react";
import {
  Container,
  Grid,
  Header,
  Icon,
  Image,
  Segment,
} from "semantic-ui-react";
import styled from "styled-components";

import analytics from "../../utils/analytics";
import ThemeContext from "../../context/theme";
import LogoJsc from "../../assets/jsc-logo.png";
import LogoPemprov from "../../assets/pemprov-logo.png";
import { textColor, secondaryTextColor } from "../../styles/theme";

const SpanCopy = styled.div`
  color: ${secondaryTextColor};
  font-size: 0.875rem;
  text-align: center;
`;

const IconSpace = styled(Icon)({
  color: textColor,
  padding: "0 0.75em !important",
});

const Footer = () => {
  const { isDark } = React.useContext(ThemeContext);

  return (
    <Segment inverted={isDark} vertical style={{ padding: "5em 0em" }}>
      <Container>
        <Grid inverted={isDark} centered stackable>
          <Grid.Row>
            <Grid.Column width={3}>
              <Image src={LogoPemprov} size="tiny" floated="left" />
              <Image src={LogoJsc} size="tiny" floated="left" />
            </Grid.Column>
            <Grid.Column width={3}>
              <Header inverted={isDark} as="h4" content="Portal CRM" />
            </Grid.Column>
            <Grid.Column width={4}>
              <Header as="h4" textAlign="center" inverted={isDark}>
                Temukan CRM di Sosial Media
              </Header>
              <div align="center">
                <a
                  href="https://web.facebook.com/JSCLounge"
                  onClick={() =>
                    analytics.sendEvent({
                      category: "Social Media",
                      action: "Clicked Link",
                      label: "Facebook",
                    })
                  }
                >
                  <IconSpace name="facebook official" size="large" />
                </a>
                <a
                  href="https://twitter.com/jsclab"
                  onClick={() =>
                    analytics.sendEvent({
                      category: "Social Media",
                      action: "Clicked Link",
                      label: "Twitter",
                    })
                  }
                >
                  <IconSpace name="twitter" size="large" />
                </a>
                <a
                  href="https://www.instagram.com/jsclab/"
                  onClick={() =>
                    analytics.sendEvent({
                      category: "Social Media",
                      action: "Clicked Link",
                      label: "Instagram",
                    })
                  }
                >
                  <IconSpace name="instagram" size="large" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCwBHhUax4ztQIsHpSJR_Cqw"
                  onClick={() =>
                    analytics.sendEvent({
                      category: "Social Media",
                      action: "Clicked Link",
                      label: "Youtube",
                    })
                  }
                >
                  <IconSpace name="youtube" size="large" />
                </a>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <SpanCopy dark={isDark}>
                Copyright &copy; 2019 Portal CRM
              </SpanCopy>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};

export default Footer;
